<template>
  <div>
    <label>
      <span v-if="label">{{ label }}</span>
    </label>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ $t('INBOX_MGMT.DELETE.AVATAR_DELETE_BUTTON_TEXT') }}
      </woot-button>
    </div>
    <input
      id="file"
      ref="file"
      type="file"
      accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
      class="avatar-uploader-input"
      @change="handleImageUpload"
    />
    <div class="avatar-uploader-actions">
      <woot-button
        type="button"
        variant="smooth"
        size="small"
        @click="openFilePicker"
      >
        {{ $t('PROFILE_SETTINGS.FORM.UPLOAD_IMAGE') }}
      </woot-button>
      <span v-if="selectedFileName" class="avatar-uploader-filename">
        {{ selectedFileName }}
      </span>
      <span v-else class="avatar-uploader-filename">
        {{ $t('PROFILE_SETTINGS.FORM.NO_IMAGE') }}
      </span>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedFileName: '',
    };
  },
  watch: {},
  methods: {
    openFilePicker() {
      this.$refs.file.click();
    },
    handleImageUpload(event) {
      const [file] = event.target.files;
      this.selectedFileName = file ? file.name : '';

      this.$emit('change', {
        file,
        url: file ? URL.createObjectURL(file) : null,
      });
    },
    onAvatarDelete() {
      this.$refs.file.value = null;
      this.selectedFileName = '';
      this.$emit('onAvatarDelete');
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}

.avatar-uploader-input {
  display: none;
}

.avatar-uploader-actions {
  display: flex;
  align-items: center;
  gap: var(--space-small);
  margin-bottom: var(--space-small);
}

.avatar-uploader-filename {
  font-size: var(--font-size-small);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
</style>
